// extracted by mini-css-extract-plugin
export default {"pageHeroWrapper":"CO2eGU","heroContent":"xFFKEr"};